import * as React from 'react'
import IconButton from '@mui/material/IconButton'
import Menu from '@mui/material/Menu'
import MoreVertIcon from '@mui/icons-material/MoreVert'

const ITEM_HEIGHT = 48

const ListActions = ({anchorEl, setAnchorEl, options = [], itemId, tableRowData}) => {
    const open = Boolean(anchorEl)
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget)
        event?.stopPropagation()
    }
    const handleClose = (event) => {
        setAnchorEl(null)
        event?.stopPropagation()
    }

    return (
        <>
            <IconButton
                aria-label="more"
                id="long-button"
                aria-controls={open ? 'long-menu' : undefined}
                aria-expanded={open ? 'true' : undefined}
                aria-haspopup="true"
                onClick={handleClick}>
                <MoreVertIcon />
            </IconButton>
            <Menu
                id="long-menu"
                MenuListProps={{
                    'aria-labelledby': 'long-button',
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                slotProps={{
                    paper: {
                        sx: {
                            maxHeight: ITEM_HEIGHT * 4.5,
                            minWidth: '20ch',
                            width: 'fit-content',
                            maxWidth: 'calc(100vw - 2rem)',
                            '& .MuiMenuItem-root': {
                                whiteSpace: 'nowrap',
                            },
                        },
                    },
                }}>
                {options.map((option, index) => {
                    const {MenuItem, ...resOptions} = option
                    return (
                        <MenuItem
                            key={`list_action_${index}`}
                            itemId={itemId}
                            handleClose={handleClose}
                            rowData={tableRowData}
                            {...resOptions}
                        />
                    )
                })}
            </Menu>
        </>
    )
}
export default ListActions
